import {defineMessages} from 'react-intl';

export default defineMessages({
  linksAbout: {
    defaultMessage: 'About Us',
    id: 'Footer.FooterPageLinks.Links.About',
  }
});
